import React, { useState } from "react";
import ContentHeader from "../../../reusableComponents/contentHeader/ContentHeader";
import GroupsIcon from "@mui/icons-material/Groups";
import Footer from "../../Footer";
import Header from "../../Header";
import MenuBar from "../../MenuBar";
import "./../manageUsers.css";
import {
  Box,
  Checkbox,
  Divider,
  FormHelperText,
  Grid,
  OutlinedInput,
  TextField,
  Typography,
} from "@mui/material";
import CustomButton from "../../../reusableComponents/CustomButton";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "../../../context/API_Client";
import { useEffect } from "react";
import LoadingLogoPage from "../../loadingPage/loadingPage";
import { customToast } from "../../../reusableComponents/customToaster/customToast";
import { nameRegex } from "../../../reusableComponents/constants";
import { colorBrandObject } from "../../../../constants/brandings";

export default function CreateRole() {
  const navigate = useNavigate();
  const { getAllPermissions, createRole, updateRole, getRoleById } = useAuth();
  const [searchParams] = useSearchParams();
  const editId = searchParams.get("editRoleId");

  const [role, setRole] = useState("");
  const [description, setDescription] = useState("");
  const [allPermissions, setAllPermissions] = useState([]);
  const [roleError, setRoleError] = useState("");
  const [isUrlValid, setIsUrlValid] = useState(true);
  const [loading, setLoading] = useState(true);
  const [disableallFields, setDisableallFields] = useState(false);
  const [paymentError, setPaymentError] = useState("");
  const [specificRoleData, setSpecificRoleData] = useState([]);

  const handleChangeRole = (e) => {
    const role = e.target.value;
    setRole(role);
    const isValid = nameRegex.test(role);
    setRoleError(isValid ? "" : "Please enter correct role name");
  };

  useEffect(() => {
    getAllPermissions(
      (data) => {
        setAllPermissions(data);
        setLoading(false);
      },
      (errorMsg) => {
        setPaymentError(errorMsg);
        customToast("error", "high", errorMsg);
        setLoading(false);
      }
    );
  }, []);
  const [selectedPermissions, setSelectedPermissions] = useState([]);
  const handleCheckboxChange = (name, isFeatureCheckbox) => {
    setSelectedPermissions((prevSelected) => {
      if (isFeatureCheckbox) {
        const featurePermissions = groupedData[name]?.permissions || [];
        const featurePermissionNames = featurePermissions.map(
          (permission) => permission.name
        );

        if (
          featurePermissionNames.every((item) => prevSelected.includes(item))
        ) {
          return prevSelected.filter(
            (item) => !featurePermissionNames.includes(item)
          );
        } else {
          return [...prevSelected, ...featurePermissionNames];
        }
      } else {
        return prevSelected.includes(name)
          ? prevSelected.filter((item) => item !== name)
          : [...prevSelected, name];
      }
    });
  };

  const groupedData = allPermissions?.reduce((acc, permission) => {
    const { featureName, featureTitle, permissionTitle, name } = permission;
    if (!acc[featureName]) {
      acc[featureName] = { featureTitle, permissions: [] };
    }
    acc[featureName].permissions.push({ permissionTitle, name });
    return acc;
  }, {});

  useEffect(() => {
    if (editId) {
      getRoleById(
        editId,
        (data) => {
          setSpecificRoleData(data);
        },
        (errorMsg) => {
          customToast("error", "high", errorMsg);
        }
      );
    }
  }, [editId]);

  useEffect(() => {
    if (Object.keys(specificRoleData)?.length) {
      setRole(specificRoleData?.name);
      setDescription(specificRoleData?.description);
      setSelectedPermissions(specificRoleData?.permissions);
    }
  }, [specificRoleData]);

  useEffect(() => {
    if (Object.keys(specificRoleData)?.length) {
      if (specificRoleData?.id === "Admin") setDisableallFields(true);
    }
  }, [specificRoleData]);

  const handleSubmitCreateRole = () => {
    createRole(
      {
        name: role,
        description: description,
        permissions: selectedPermissions,
      },
      function (data) {
        customToast("success", "high", "Role created successfully");
        if (data) {
          navigate("/settings/manageTeam");
        }
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };
  const handleSubmitUpdateRole = () => {
    updateRole(
      editId,
      {
        name: role,
        description: description,
        permissions: selectedPermissions,
      },
      function (data) {
        customToast("success", "high", "Role updated successfully");

        if (data) {
          navigate("/settings/manageTeam");
        }
      },
      function (error) {
        customToast("error", "high", error);
      }
    );
  };

  return (
    <>
      {allPermissions?.length === 0 && loading ? (
        <LoadingLogoPage />
      ) : (
        <div className="content-wrapper" style={{ backgroundColor: "white" }}>
          <section className="content">
            <div className="payment-link-main-div">
              <ContentHeader
                firstHeading="Assign roles to your team members"
                secondHeading={
                  editId
                    ? "Edit user roles and asign it to the respective team members"
                    : "Create user roles and asign it to the respective team members"
                }
                icon={<GroupsIcon sx={{ color: colorBrandObject.sideBarSelectedOptionBackground }} />}
              />
              <div
                style={{ width: "100%", marginTop: "32px", display: "flex" }}
              >
                <div style={{ width: "60%" }}>
                  <Typography
                    className="labelRegular"
                    style={{
                      color: "var(--global-neutral-grey-1100, #2D2B32)",
                    }}
                  >
                    Role*
                  </Typography>
                  <TextField
                    variant="outlined"
                    placeholder="Enter Role"
                    id="outlined-basic"
                    sx={{
                      borderRadius: "8px",
                      marginTop: "8px",
                      width: "100%",
                      height: "42px",
                    }}
                    size="small"
                    fullWidth
                    value={role}
                    onChange={handleChangeRole}
                    disabled={disableallFields}
                  />
                  {roleError?.length > 0 && role?.length > 0 && (
                    <FormHelperText
                      error={!isUrlValid}
                      style={{
                        color: "#B9232F",
                        fontSize: "10px",
                        marginTop: "2px",
                      }}
                    >
                      <img
                        src="/assets/errorOutline.svg"
                        style={{ height: "12px", width: "12px" }}
                      />
                      {roleError}
                    </FormHelperText>
                  )}
                </div>
              </div>
              <Box sx={{ mt: "28px" }}>
                <Typography
                  htmlFor="description"
                  className="labelRegular"
                  style={{
                    color: "var(--global-neutral-grey-1100, #2D2B32)",
                  }}
                >
                  Description
                </Typography>

                <OutlinedInput
                  multiline
                  rows={3}
                  size="small"
                  placeholder="Enter Description"
                  aria-describedby="outlined-name-helper-text"
                  sx={{ width: "60%", height: "80px", marginTop: "8px" }}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  disabled={disableallFields}
                />
              </Box>
              <div className="permissionDiv">
                <Typography className="b1Regular font-neutral-grey">
                  Permissions
                </Typography>
                {Object.keys(groupedData)?.map((featureName) => {
                  const { featureTitle, permissions } =
                    groupedData[featureName];
                  const isFeatureSelected = permissions.every(({ name }) =>
                    selectedPermissions.includes(name)
                  );

                  return (
                    <>
                      <div
                        key={featureName}
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          marginTop: "20px",
                          width: "100%",
                          cursor: "pointer",
                        }}
                        className="manageUsersCheckbox"
                        onClick={() => handleCheckboxChange(featureName, true)}
                      >
                        <Checkbox
                          sx={{
                            '& .MuiSvgIcon-root': {
                              color: colorBrandObject?.secondaryButtonColor,
                            },
                            '&.Mui-checked': {
                              color: colorBrandObject?.secondaryButtonColor,
                              '& .MuiSvgIcon-root': {
                                fill: colorBrandObject?.secondaryButtonColor,
                              },
                            },
                          }}
                          checked={isFeatureSelected}
                          disabled={disableallFields}
                        />
                        <Typography
                          className="labelSemiBold font-neutral-grey"
                          style={{
                            marginLeft: "8px",
                          }}
                        >
                          {featureTitle}
                        </Typography>
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          marginLeft: "24px",
                        }}
                        className="manageUsersCheckbox"
                      >
                        <Grid container spacing={1}>
                          {permissions?.map(
                            ({ permissionTitle, name, idx }) => (
                              <Grid item xs={12} sm={6} md={4} key={idx}>
                                <div
                                  key={name}
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                    marginTop: "8px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handleCheckboxChange(name, false)
                                  }
                                >
                                  <Checkbox
                                    sx={{
                                      '& .MuiSvgIcon-root': {
                                        color: colorBrandObject?.secondaryButtonColor,
                                      },
                                      '&.Mui-checked': {
                                        color: colorBrandObject?.secondaryButtonColor,
                                        '& .MuiSvgIcon-root': {
                                          fill: colorBrandObject?.secondaryButtonColor,
                                        },
                                      },
                                    }}
                                    checked={selectedPermissions.includes(name)}
                                    disabled={disableallFields}
                                  />
                                  <Typography
                                    className="labelRegular font-neutral-grey"
                                    style={{
                                      marginLeft: "8px",
                                      marginRight: "8px",
                                    }}
                                  >
                                    {permissionTitle}
                                  </Typography>
                                </div>
                              </Grid>
                            )
                          )}
                        </Grid>
                      </div>
                      <Divider
                        style={{
                          margin: "16px 0px",
                        }}
                      />
                    </>
                  );
                })}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "end",
                    marginTop: "24px",
                  }}
                >
                  <CustomButton
                    text={"Cancel"}
                    type={"primary"}
                    variant={"outlined"}
                    size={"sm"}
                    onClick={() => navigate("/settings/manageTeam")}
                  />
                  <div style={{ marginLeft: "12px" }}>
                    <CustomButton
                      text={"Save Role"}
                      type={"primary"}
                      variant={"contained"}
                      size={"sm"}
                      disabled={
                        role?.length == 0 ||
                        selectedPermissions?.length === 0 ||
                        disableallFields
                      }
                      onClick={() => {
                        !editId
                          ? handleSubmitCreateRole()
                          : handleSubmitUpdateRole();
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      )}
    </>
  );
}
